module.exports = __webpack_public_path__ + "static/img/anxun22.009b1e01.png";